// externals
import isEqual_ from 'lodash.isequal';

// libraries
import { ITradeInState, IVehicleOption } from '@makemydeal/dr-activities-common';

// selectors
import * as tradeInSelectors from '../store/mmd/tradeIn';
import * as tradeInRoutes from './routes';
import { LOAN_BALANCE_OPTION_TYPES } from './constants';

const isEqual = isEqual_;

export const hasOptionsData = (tradeIn) => {
    const options = tradeInSelectors.getTradeInVehicleOptions(tradeIn);
    return !!options;
};

export const hasVehicleOptChanged = (tradeInState) => {
    const vehicleOptions = tradeInSelectors.getTradeInSavedVehicleOpts(tradeInState);
    const tradeinOptions = tradeInSelectors.getTradeInVehicleOptions(tradeInState);
    return !isEqual(tradeinOptions, vehicleOptions);
};

export const getTradeInValuation = (state) => {
    const tradeInComponent = state.tradeInComponent;
    const amountOwed = tradeInSelectors.getTradeInAmountOwed(tradeInComponent);
    const value = tradeInSelectors.getTradeInValue(tradeInComponent);
    const shouldIncludeTradeIn = tradeInSelectors.getAmountAppliedToFinancing(tradeInComponent);

    const tradeInValuation = {
        amountOwed,
        shouldIncludeTradeIn,
        value
    };

    return tradeInValuation;
};

export const getFormattedTradeInVehicleOptions = (tradeIn: ITradeInState): IVehicleOption => {
    const vehicleOptions = tradeInSelectors.getTradeInVehicleOptions(tradeIn) || {};
    const formattedVehicleOptions = {};
    for (const [key, value] of Object.entries(vehicleOptions)) {
        if (value.options?.length) {
            formattedVehicleOptions[key] = {
                ...value,
                options: value.options.map((option) => {
                    return option?.displayName
                        ? {
                              ...option,
                              // handling string containing a double-quote, for example: "Premium Wheels 19\"+"
                              displayName: option.displayName.replace(/(\\){,1}"/g, '\\"')
                          }
                        : option;
                })
            };
        }
    }
    return formattedVehicleOptions;
};

export const getBackRouteOfLoanBalance = (loanBalanceOption?: string, hasLoan?: boolean | null): string => {
    if (!hasLoan) {
        return tradeInRoutes.TRADE_LOAN_BALANCE;
    }
    return loanBalanceOption === LOAN_BALANCE_OPTION_TYPES.LOAN_ESTIMATE
        ? tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE
        : tradeInRoutes.TRADE_FIND_OPEN_LOAN;
};
